<script>
// Card do plano Tripteev (benefícios: uma linha da descrição por item), visual do card do Experts
export default {
  locales: {
    pt: {
      'membership': 'adesão',
      'month': 'mês',
      'then': 'depois',
      'per month': 'por mês',
      '30 days of access per payment': '30 dias de acesso por pagamento',
      'MOST CHOSEN': 'MAIS ESCOLHIDO',
      'With the membership, you are activated in the combo': 'Com a adesão, você se ativa no combo',
    },
    es: {
      'membership': 'adhesión',
      'month': 'mes',
      'then': 'después',
      'per month': 'por mes',
      '30 days of access per payment': '30 días de acceso por pago',
      'MOST CHOSEN': 'MÁS ELEGIDO',
      'With the membership, you are activated in the combo': 'Con la adhesión, te activas en el combo',
    },
  },
  props: {
    plan: {
      type: Object,
      default: () => ({}),
    },
    recommended: {
      type: Boolean,
      default: false,
    },
    // Texto do botão; vazio esconde o botão (ex.: tela de confirmação)
    action: {
      type: String,
      default: "",
    },
  },
  computed: {
    isAdhesion() {
      return this.plan.type == "adhesion";
    },
    benefits() {
      if (!this.plan.description) {
        return [];
      }
      return this.plan.description
        .split(/\r?\n/)
        .map((row) => row.trim())
        .filter((row) => row.length > 0);
    },
  },
};
</script>

<template>
  <article class="tripteev-card" :class="{ 'is-recommended': recommended }" aria-labelledby="tripteev-plan-name">
    <span class="tripteev-card-bar" aria-hidden="true"></span>
    <div class="tripteev-card-head">
      <h3 id="tripteev-plan-name" class="tripteev-card-name">{{ plan.name }}</h3>
      <span v-if="recommended" class="tripteev-card-badge">{{ t('MOST CHOSEN') }}</span>
    </div>
    <p class="tripteev-card-price">
      {{ plan.value | currency }} <small>/{{ isAdhesion ? t('membership') : t('month') }}</small>
    </p>
    <p v-if="isAdhesion && plan.monthly" class="tripteev-card-month">{{ t('then') }} {{ plan.monthly | currency }} {{ t('per month') }}</p>
    <p v-else class="tripteev-card-month">{{ t('30 days of access per payment') }}</p>
    <div v-if="isAdhesion && plan.combo" class="tripteev-card-combo">
      <i class="bx bx-gift" aria-hidden="true"></i>
      <span>{{ t('With the membership, you are activated in the combo') }} <strong>{{ plan.combo }} Tripteev</strong>.</span>
    </div>
    <ul v-if="benefits.length > 0" class="tripteev-card-benefits">
      <li v-for="(benefit, index) in benefits" :key="index">
        <i class="bx bx-check" aria-hidden="true"></i>
        <span>{{ benefit }}</span>
      </li>
    </ul>
    <div v-if="action" class="tripteev-card-action">
      <button class="btn btn-default btn-lg btn-block text-uppercase" v-on:click="$emit('choose', plan)">
        {{ action }}
      </button>
    </div>
  </article>
</template>
